import React from 'react';
import {
  Route,
  RouteComponentProps,
  Switch,
  withRouter,
} from 'react-router-dom';
import { Translate } from 'react-redux-i18n';
import { PAIR_DEVICE_ONE, PAIR_DEVICE_TWO } from '../../../../../routes';
import PairDeviceStepOne from './PairDeviceStepOne';
import PairDeviceStepTwo from './PairDeviceStepTwo';

type Props = RouteComponentProps & {
  onClose: () => void
};

function PairDevice(props: Props) {
  return (
    <div className="pair-device-container">
      <div className="centered-form">
        <div className="drawer-title">
          <h3>
            <Translate value="PAIR_DEVICE.PAIR_DEVICE" />
          </h3>
        </div>
        <Switch>
          <Route
            path={PAIR_DEVICE_ONE}
            render={() => (
              <PairDeviceStepOne
                onClose={props.onClose}
              />
            )}
          />
          <Route
            path={PAIR_DEVICE_TWO}
            render={() => (
              <PairDeviceStepTwo
                onClose={props.onClose}
              />
            )}
          />
        </Switch>
      </div>
    </div>
  );
}

export default withRouter(PairDevice);
